import { IEquipmentCategoryItem, IStageEquipmentCategory } from "Venues/types";
import { equipmentCategoryList } from "./getEquipmentCategories";

export const mergeEquipmentCategories = (
  stageEquipmentCategories?: IStageEquipmentCategory[] | undefined
) => {
  // if stageEquipmentCategories is empty, then return hardcoded list
  if (!stageEquipmentCategories) {
    return equipmentCategoryList;
  }

  // reduce stageEquipmentCategories to object with "category" as key
  const stageEquipmentCategoryMap: { [key: string]: any } =
    stageEquipmentCategories?.reduce(
      (acc, { category, ...rest }) => ({
        ...acc,
        [category]: rest,
      }),
      {}
    ) || {};

  return equipmentCategoryList.map((mainCategory: IEquipmentCategoryItem) => {
    // merge hardcoded subcategory with info from API
    const mergedSubcategories = mainCategory.categories.map(subcategory => ({
      ...subcategory,
      ...stageEquipmentCategoryMap?.[subcategory.category],
    }));

    // merge hardcoded main category with info from API
    return {
      ...mainCategory,
      categories: mergedSubcategories,
      ...stageEquipmentCategoryMap?.[mainCategory.category],
    };
  });
};
